import * as Yup from 'yup';
import { MAX_GLOBAL_AGGREGATE_THRESHOLD } from '@brighterion/utils/constants';

export const ThresholdSchema = (
    shouldValidate: boolean = true,
    maxGlobalAggregateThreshold = MAX_GLOBAL_AGGREGATE_THRESHOLD
) => {
    /**
     * In order to dynamically change validation rules, you want to use Yup.lazy
     * in order to access the value and do something based off of said value.
     *
     * In this case, check if we should validate and check if the value is null.
     */
    return Yup.lazy((someVal) => {
        if (shouldValidate && someVal !== null) {
            return Yup.number()
                .required()
                .positive()
                .integer()
                .max(maxGlobalAggregateThreshold)
                .test('is-not-decimal', 'non-decimal values only', (value) => !!value && value % 1 === 0);
        }
        return Yup.string().nullable();
    });
};
